import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../components/Layout/MainLayout';
import DataCenterCard from '../../../components/Dashboard/DataCenterCard';
import { BackIcon, DatabaseIcon, PcIcon } from '../../../components/Dashboard/DataCenterIcons';
import '../../../assets/styles/CDPage.css';

const CDPage: React.FC = () => {
  const navigate = useNavigate();
  const handleCardClick = (path = "", isEnabled = false) => { // Fixed parameter name
    console.log('Card clicked - path:', path, 'isEnabled:', isEnabled); // Debug log
    if (isEnabled && path) {
      navigate(path);
    }
    // If disabled, do nothing
  };
  const lookupTypes = [
    {
      id: 'database-counts',
      title: 'Database Counts Lookups',
      icon: <DatabaseIcon />,
      enabled: true,
      path: '/data-centers/cd/database-counts',
    },
    {
      id: 'pc-counts',
      title: 'PC Counts Lookups',
      icon: <PcIcon />,
      path: '/data-centers/cd/pc-counts',
      enabled: true,
      disabledMessage: "Under Development"

    },
  ];

  return (
    <MainLayout>
      <div className="cd-page">
        {/* Back Button */}
        <div className="cd-back-button-container">
          <button
            onClick={() => navigate('/dashboard')}
            className="cd-back-button"
          >
            <BackIcon />
            Back
          </button>
        </div>

        {/* Main Content */}
        <div className="cd-grid">
          {lookupTypes.map((type) => (
            <DataCenterCard
              key={type.id}
              title={type.title}
              icon={type.icon}
              onClick={() => handleCardClick(type.path, type.enabled)} // Pass dc.enabled directly
              isEnabled={type.enabled}
              disabledMessage={type.disabledMessage}
            />
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default CDPage;
